import type {
  FullTextConstraint,
  HotelConstraint,
} from '@libs/constraint-builder';
import { serializeConstraint } from '@libs/constraint-builder';
import type { AccommodationType } from '@libs/trip-planner-interfaces';
import type { QueryString } from '@libs/utils';
import { renderQuery } from '@libs/utils';

import type { GetHotelsEndpointIncludedProperties } from './types';

type GetHotelsQueryStringParams =
  | 'SearchText'
  | 'AdditionalSearchText'
  | 'MaxNumberOfHotels'
  | 'PerfectMatchOnly'
  | 'HotelTypes';
export type GetHotelsQueryString = QueryString<GetHotelsQueryStringParams>;

export function getHotelsUrlParamsQueryString(
  constraint: HotelConstraint,
  hotelTypes: AccommodationType[]
): GetHotelsQueryString {
  const shouldAddHotelTypesToQuery = (
    accomodationType: AccommodationType[]
  ): boolean => {
    const accommodationTypesAmount = 3;
    return (
      accomodationType.length > 0 &&
      accomodationType.length !== accommodationTypesAmount
    );
  };

  const fullTextConstraint = constraint.selection as FullTextConstraint;
  const query: GetHotelsQueryString = {
    SearchText: [serializeConstraint(constraint)],
    AdditionalSearchText: constraint.hotelName
      ? [constraint.hotelName]
      : undefined,
    MaxNumberOfHotels: constraint.maxNumberOfHotels
      ? [constraint.maxNumberOfHotels.toString()]
      : undefined,
    PerfectMatchOnly: fullTextConstraint?.perfectMatchOnly
      ? ['true']
      : undefined,
    HotelTypes: shouldAddHotelTypesToQuery(hotelTypes) ? hotelTypes : undefined,
  };

  return query;
}

export function getHotelsUrlBuilder(
  constraint: HotelConstraint,
  hotelTypes: AccommodationType[],
  includedProperties: GetHotelsEndpointIncludedProperties
): string {
  const query = {
    ...getHotelsUrlParamsQueryString(constraint, hotelTypes),
    Include: includedProperties.includeValues,
    IncludeGroup: includedProperties.includeGroupValues.length
      ? includedProperties.includeGroupValues
      : undefined,
  };

  return `Hotels/GetHotels?${renderQuery(query)}`;
}
